// components/Modal/RequestCancellationModal.js

import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import Typography from '../Typography';
import Button from '../Button/Button';
import InputTextArea from '../Input/InputTextArea';
import { theme } from '../../theme';

const RequestCancellationModal = ({ isOpen, onClose, onConfirm, isLoading = false }) => {
  const { t } = useTranslation('requestCancellationModal');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(message.trim());
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  // Limpiar el mensaje cuando el modal se cierre
  React.useEffect(() => {
    if (!isOpen) {
      setMessage('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Modal onClose={handleClose} title={t('title')}>
      <ModalContent>
        <ModalHeader>
          <Typography $variant="body-1-regular" color={theme.colors.defaultStrong}>
            {t('description')}
          </Typography>
        </ModalHeader>

        <Form onSubmit={handleSubmit}>
          <TextAreaContainer>
            <InputTextArea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={t('placeholder')}
              rows={6}
              maxLength={500}
              style={{ minHeight: '120px', resize: 'vertical' }}
            />
            <CharacterCount>
              {message.length}/500
            </CharacterCount>
          </TextAreaContainer>

          <ButtonContainer>
            <Button
              type="button"
              size="l"
              sizeTablet="l"
              sizeMobile="m"
              $variant="ghost"
              onClick={handleClose}
              disabled={isLoading}
            >
              {t('buttons.cancel')}
            </Button>
            <Button
              type="submit"
              size="l"
              sizeTablet="l"
              sizeMobile="m"
              $variant="primary"
              disabled={isLoading || !message.trim()}
            >
              {isLoading ? t('buttons.sending') : t('buttons.submit')}
            </Button>
          </ButtonContainer>
        </Form>
      </ModalContent>
    </Modal>
  );
};

export default RequestCancellationModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  max-width: 500px;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const TextAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  position: relative;
`;



const CharacterCount = styled.span`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors.defaultWeak};
  font-size: 12px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.sm};
  justify-content: space-between;
`;